import api from './index';
//
let exports = {};

exports.getDevcInspectFlowPageList = function (data, callback) {        // 设备检验流程列表
    api.post('/devc/inspect/flow/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getDevcInspectFlowInfo = function (params, callback) {        // 设备检验流程详情
    api.get('/devc/inspect/flow/info/get')
    .params(params)
    .done(callback)
    .go();
};
exports.saveDevcInspectFlow = function (data, callback) {        // 设备检验流程-保存
    api.post('/devc/inspect/flow/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateDevcInspectFlow = function (data, callback) {        // 设备检验流程-修改
    api.post('/devc/inspect/flow/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateDevcInspectFlowForDisabled = function (data, callback) {        // 设备检验流程-启禁用
    api.post('/devc/inspect/flow/update/for/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteDevcInspectFlow = function (data, callback) {        // 设备检验流程-删除
    api.post('/devc/inspect/flow/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//

// 获取设备检验计划列表
exports.getDevcInspectPlanList = function (postData, callback) {
    api.post('/devc/inspect/plan/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 获取设备检验计划详情
exports.getDevcInspectPlanDetail = function (params, callback) {
    api.get('/devc/inspect/plan/detail/get')
    .params(params)
    .done(callback)
    .go();
};
// 保存设备检验计划 - 一个服务商一个检验计划
exports.saveDevcInspectPlanForOneServicer = function (data, callback) {
    api.post('/devc/inspect/plan/for/oneServicer/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存设备检验计划 - 一个服务商一个检验计划 - 批量
exports.saveDevcInspectPlanForOneServicerBatch = function (data, callback) {
    api.post('/devc/inspect/plan/save/do/for/oneServicer/batch')
    .data(data)
    .done(callback)
    .go();
};
// 保存设备检验计划
exports.saveDevcInspectPlan = function (data, callback) {
    api.post('/devc/inspect/plan/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 设置设备检验计划截止时间
exports.updateYqFinishTime = function (data, callback) {
    api.post('/devc/inspect/plan/devc/yqFinishTime/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 设置设备检验计划要求完成小时数
exports.updateYqFinishHours = function (data, callback) {
    api.post('/devc/inspect/plan/devc/yqFinishHours/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 设置设备检验计划预警小时数
exports.updateYqFinishAotHr = function (data, callback) {
    api.post('/devc/inspect/plan/devc/yqFinishAotHr/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 设置设备检验计划要求信息
exports.updateInspectPlanDeviceYqInfo = function (data, callback) {
    api.post('/devc/inspect/plan/devc/yqInfo/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 修改设备检验计划子项
exports.updateDevcInspectPlanDevc = function (data, callback) {
    api.post('/devc/inspect/plan/devc/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 结束检验计划
exports.doDevcInspectPlanTerminated = function (params, callback) {
    api.post('/devc/inspect/plan/terminated/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 结束检验计划
exports.doDevcInspectPlanTerminatedBatch = function (params, callback) {
    api.post('/devc/inspect/plan/terminated/batch/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 删除设备检验计划
exports.deleteDevcInspectPlan = function (data, callback) {
    api.post('/devc/inspect/plan/delete/do')
    .params(data)
    .done(callback)
    .go();
};
// 批量删除设备检验计划
exports.doBatchDeleteDevcInspectPlan = function (data, callback) {
    api.post('/devc/inspect/plan/batch/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 查询设备中是否有未执行完的检验计划
exports.updateDevcInspectPlanNotTerminated = function (data, callback) {
    api.post('/devc/inspect/plan/not/terminated/get/by/devcXIds')
    .data(data)
    .done(callback)
    .go();
};
// 修改检验计划中的服务商及合约信息
exports.updateInspectPlanDevcByDevcXIds = function (data, callback) {
    api.post('/devc/inspect/plan/device/update/do/by/devcXIds')
    .data(data)
    .done(callback)
    .go();
};
// 修改检验计划中的服务商信息
exports.updateInspectPlanDevcByDeviceIds = function (data, callback) {
    api.post('/devc/inspect/plan/device/update/do/by/deviceIds')
    .data(data)
    .done(callback)
    .go();
};
// 修改检验计划中合同信息
exports.updateInspectPlanDevcContractByDevcXIds = function (data, callback) {
    api.post('/devc/inspect/plan/device/contract/update/do/by/devcXIds')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcInspect.js
// module id = 99
// module chunks = 0